<template>
  <PopupWithSlot
    v-if="post"
    @blur="() => popupClose()"
    @close="() => popupClose()"
    :customScrollElement="settings.scrollElement"
  >
    <FashionTile
      :fashion="post"
      :fashionImage="fashionImage"
      :settings="settings"
      :popupSettings="popupSettings"
      :hasPrevPost="hasPrevPost"
      :hasNextPost="hasNextPost"
      :isSinglePost="postList.length === 1"
      :popupText="popupText"
      @changePostRequest="
        (direction) => (direction > 0 ? popupNext() : popupPrev())
      "
      titleMode="postsCount"
    >
      <template v-slot:imageArea>
        <div class="frisbuy-popup-media">
          <div
            :class="{
              [`frisbuy-provider-${post.frisbuyPost.providerType}`]:
                !isCensored && false,
            }"
          ></div>
          <div
            v-if="popupSettings.showReportButton && !isPlaying"
            class="frisbuy-complain-button"
            @click="showComplainForm = true"
          >
            <svg
              width="12"
              height="11"
              viewBox="0 0 12 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.79753 0.0286079C5.53223 0.0911624 5.27861 0.271445 5.08505 0.535087C5.00335 0.646357 0.986797 7.36038 0.301285 8.53157C0.0909552 8.89089 0.0188286 9.08942 0.0039888 9.34978C-0.00589645 9.52317 0.000796937 9.58208 0.0445541 9.7073C0.182852 10.103 0.531671 10.3225 1.1058 10.3752C1.46515 10.4083 10.5349 10.4083 10.8942 10.3752C11.4683 10.3225 11.8171 10.103 11.9554 9.7073C11.9992 9.58208 12.0059 9.52317 11.996 9.34978C11.9812 9.08942 11.909 8.89089 11.6987 8.53157C11.0132 7.36038 6.99665 0.646357 6.91495 0.535087C6.71488 0.262565 6.44843 0.0787991 6.17153 0.022334C6.0181 -0.00894327 5.9521 -0.00783608 5.79753 0.0286079ZM6.31235 2.75388C6.61243 2.85641 6.8275 3.12174 6.88353 3.4585C6.90887 3.61101 6.88834 3.79067 6.76245 4.51749C6.64688 5.1847 6.52899 5.93999 6.48886 6.2705C6.46804 6.44176 6.44553 6.61561 6.43881 6.65685L6.42659 6.73181H6.002H5.57739L5.56071 6.54152C5.52477 6.13169 5.39862 5.34 5.16468 4.05618C5.10028 3.70272 5.09399 3.63197 5.11412 3.48728C5.1699 3.08651 5.45214 2.78207 5.82688 2.71843C5.9616 2.69557 6.19058 2.71227 6.31235 2.75388ZM6.36921 7.33033C6.52399 7.40372 6.7291 7.59208 6.79835 7.72436C6.88631 7.89249 6.91766 8.09327 6.88376 8.27148C6.868 8.35426 6.83324 8.46353 6.80652 8.51427C6.73098 8.6576 6.5419 8.82513 6.3653 8.90517C6.22626 8.96816 6.18182 8.97688 6 8.97688C5.81818 8.97688 5.77374 8.96816 5.6347 8.90517C5.459 8.82554 5.26909 8.65774 5.19455 8.51628C5.1135 8.36245 5.08324 8.15657 5.11619 7.98334C5.15375 7.78599 5.23155 7.64377 5.37278 7.51434C5.59973 7.30631 5.71804 7.26166 6.02382 7.26867C6.2085 7.27291 6.27202 7.28424 6.36921 7.33033Z"
                fill="white"
              />
            </svg>
            {{ popupText.complain }}
          </div>
          <div
            class="frisbuy-complain-form"
            :class="{ 'frisbuy-complain-message': complainSended }"
            v-if="showComplainForm"
            @touchemove.stop
          >
            <template v-if="complainSended">
              <div class="frisbuy-complain-form__title">
                {{ popupText.complainAccepted }}<br />
                {{ popupText.afterAccept }}
              </div>
              <div class="frisbuy-complain-form__buttons">
                <button @click="showComplainForm = false">
                  {{ popupText.ok }}
                </button>
              </div>
            </template>
            <template v-else>
              <div class="frisbuy-complain-form__title">
                {{ popupText.confirm }}
              </div>
              <div class="frisbuy-complain-form__note">
                {{ popupText.complainNote }}
              </div>
              <div class="frisbuy-complain-form__email">
                <label>E-Mail*</label>
                <input
                  type="email"
                  @input="complainError = null"
                  v-model="email"
                />
              </div>
              <div class="frisbuy-complain-form__text">
                <label>{{ popupText.complainText }}</label>
                <textarea
                  cols="30"
                  rows="5"
                  v-model="complainText"
                  @input="complainError = null"
                ></textarea>
              </div>
              <div class="frisbuy-complain-form__buttons">
                <button @click="showComplainForm = false" :disabled="inSending">
                  {{ popupText.cancel }}
                </button>
                <button
                  :class="{ 'frisbuy-button-loading': inSending }"
                  @click="sendComplain"
                  :disabled="inSending"
                >
                  {{ popupText.submit }}
                </button>
              </div>
              <div class="frisbuy-complain-form__error" v-if="complainError">
                {{ complainError }}
              </div>
            </template>
          </div>

          <PopupImage
            v-if="
              !isPlaying ||
              !mediaIsVideo ||
              (typeof popupVideoPositionStyles !== 'undefined' &&
                Object.keys(popupVideoPositionStyles).length > 0)
            "
            :style="{
              visibility: !isPlaying || !mediaIsVideo ? 'visible' : 'hidden',
            }"
            :media="currentMedia"
            :post="post"
            :settings="settings"
            ref="postImage"
          />

          <div
            class="frisbuy-media-play"
            v-if="currentMedia.videoUrl && !isPlaying"
            @click="isPlaying = true"
          >
            <img :src="`${envDomain}/images/widget/play.svg`" />
          </div>

          <div
            v-if="currentMedia.videoUrl"
            :class="{ 'frisbuy-video-wrapper': isPlaying }"
            :style="popupVideoPositionStyles"
          >
            <video
              v-show="isPlaying"
              :controls="isPlaying"
              loop="true"
              controlsList="nodownload"
              :autoplay="popupSettings.autoplayVideo"
              @loadeddata="videoLoaded"
              ref="video"
              @pause="pauseVideo"
              playsinline
            >
              <source
                :key="post.id"
                type="video/mp4"
                @error="errorVideoHandler"
              />
            </video>
          </div>

          <div class="frisbuy-gallery-navigation" v-if="isMultiPosts && false">
            <div
              class="frisbuy-navigation-button"
              v-if="mediaIndex"
              @click="navigate(mediaIndex - 1)"
            >
              <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                <polyline
                  stroke="currentColor"
                  fill="none"
                  points="16,24 8,16 16,8"
                />
              </svg>
            </div>
            <span></span>
            <div
              class="frisbuy-navigation-button"
              v-if="mediaIndex !== post.media.length - 1"
              @click="navigate(mediaIndex + 1)"
            >
              <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                <polyline
                  stroke="currentColor"
                  fill="none"
                  points="8,8 16,16 8,24"
                />
              </svg>
            </div>
          </div>

          <div class="frisbuy-gallery-pagination" v-if="isMultiPosts && false">
            <div
              v-for="(mediaItem, index) in post.media"
              :key="index"
              :class="{
                'frisbuy-gallery-page': true,
                active: index == mediaIndex,
                'frisbuy-video-play': isPlaying,
              }"
              @click="navigate(index)"
            ></div>
          </div>
        </div>
      </template>
    </FashionTile>
  </PopupWithSlot>
</template>

<style lang="scss" src="./ProductPopup.scss"></style>
<style scoped lang="scss">
.frisbuy-popup-with-slot {
  z-index: 99999999999999;

  .frisbuy-video-wrapper {
    padding-bottom: 100%;
  }
}
</style>

<script>
// Components
import defaultPopup from "@/gallery/popup/popup.vue";
import PopupWithSlot from "../components/PopupWithSlot.vue";
import FashionTile from "../components/FashionTile.vue";
import PopupImage from "./PopupImage/PopupImage.vue";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";

export default {
  mixins: [defaultPopup],

  components: {
    PopupWithSlot,
    FashionTile,
    PopupImage,
  },

  mounted() {
    console.log("PopupWithSlot");
  },

  computed: {
    hasPrevPost() {
      return this.postIndex > 0;
    },

    hasNextPost() {
      return this.postIndex < this.postList.length - 1;
    },

    fashionImage() {
      // TODO: write condition for select image resolution
      const isHighResImage = true;

      if (isHighResImage) {
        return this.post.media[0].imageHighResolutionUrl;
      } else {
        return this.post.media[0].imageUrl;
      }
    },
  },

  methods: {
    getDomainSubstitute(srcUrl) {
      return DomainSubstitute(srcUrl);
    },

    errorVideoHandler(e) {
      MediaCatcher(e, 2, widgetTypes.SHOP_THE_LOOK);
    },
  },
};
</script>
